// extracted by mini-css-extract-plugin
module.exports = {"root":"a10a3f92e9--root--V0fmY","title":"a10a3f92e9--title--s8IlR","button":"a10a3f92e9--button--YkTOe"};